import { ReactNode, ReactElement } from "react";
import { ReactComponent as ExclamationCircleIcon } from "@fortawesome/fontawesome-free/svgs/solid/exclamation-circle.svg";
import { ReactComponent as ExclamationTriangleIcon } from "@fortawesome/fontawesome-free/svgs/solid/exclamation-triangle.svg";
import ReactMarkdown from "react-markdown";
import take from "lodash/take";

function ErrorIcon() {
  return (
    <div aria-hidden="true" className="errorIcon">
      <ExclamationCircleIcon height={20} fill="currentColor" />
    </div>
  );
}

function WarningIcon() {
  return (
    <div aria-hidden="true" className="errorIcon">
      <ExclamationTriangleIcon height={20} fill="currentColor" />
    </div>
  );
}

export function FieldError({
  id,
  messages,
  className = "errors",
}: {
  id: string;
  messages: ReactNode[];
  className?: "errors" | "warnings";
}): ReactElement | null {
  if (messages.length === 0) {
    return null;
  }
  const Icon = className === "errors" ? ErrorIcon : WarningIcon;
  return (
    <div id={id} className={className}>
      <Icon />
      {take(messages, 1).map((message, index) => (
        /* There's nothing else we can use here really, and
           error messages should never change order */
        /* eslint-disable-next-line react/no-array-index-key */
        <div className="error" key={index}>
          {typeof message === "string" ? (
            <ReactMarkdown>{message}</ReactMarkdown>
          ) : (
            message
          )}
        </div>
      ))}
    </div>
  );
}
